import React from 'react';
import PropTypes from 'prop-types';

// Common Components
import CTA from '../common/CTA/CTA.js';

// Styles
import styles from './GetMore.module.scss';

const GetMore = ({ data }) => {
  return(
    <section className={`container-fluid ${styles.wrapper}`}>
      <div className="flex-row">
        <div className="col-xs-12">
          {data && data.heading && <h2 className={styles.heading} dangerouslySetInnerHTML={{ __html:data.heading}}></h2>}
          {data && data.bodyCopy && <p className={styles.bodyCopy}>{data.bodyCopy}</p>}
           {data && data.cta && <div className={styles.ctaWrapper}><CTA data={data.cta} /></div> }
          {data && data.disclaimer && <p className={styles.disclaimer}>{data.disclaimer}</p>}
        </div>
      </div>
    </section>
  )
};

GetMore.propTypes = {
  data: PropTypes.object
};

GetMore.defaultProps = {
  data: {}
}

export default GetMore;
